import { SET_GUEST_INFO } from './../constants/actionTypes'

const newguest = (store = {}, action = {}) => {
  if(action.type === SET_GUEST_INFO){
    return action.data
  }
  else{
    return store
  }
}

export default newguest
